import React from 'react';
import { connect } from 'react-redux';

import clsx from 'clsx';
import { IconButton, Color } from '@americanexpress/aqx-components';
import { sendDTMClickEvent } from 'service_modules/models/dtm-tagging';
import { getToggleButtonData } from './redux';
import parseArrayToObject from 'src/universal/utils/parseArrayToObject';

const CollapseToggleButton = ({
  caratDirection,
  setCaratDirection,
  toggleButtonData
}) => {
  const dtmEvents = parseArrayToObject(toggleButtonData.dtmEvents || [], 'key');
  const iconButtonProps = {
    directory: 'dls',
    onClick: () => {
      setCaratDirection(caratDirection === 'down' ? 'up' : 'down');
      sendDTMClickEvent(dtmEvents[caratDirection]);
    },
    theme: { color: Color.BrightBlue }
  };

  return (
    <>
      <li>
        <IconButton
          {...iconButtonProps}
          imageName="dls-icon-up-filled"
          className={clsx('carat-button', { shouldRender: caratDirection === 'up' })}
          ariaLabel="expand"
        />
      </li>
      <li>
        <IconButton
          {...iconButtonProps}
          imageName="dls-icon-down-filled"
          className={clsx('carat-button', {
            shouldRender: caratDirection === 'down'
          })}
          ariaLabel="collapse"
        />
      </li>
    </>
  );
};

const mapStateToProps = state => ({
  toggleButtonData: getToggleButtonData(state)
});

export default connect(mapStateToProps)(CollapseToggleButton);
